//imports
import {
    CONFIRM_USER_REQUEST,
    CONFIRM_USER_RESULT,
    CONFIRM_USER_VERIFICATE_CODE_REQUEST,
    CONFIRM_USER_VERIFICATE_CODE_RESULT,
} from 'Redux/actionTypes';

export const confirmUserRequest = (username, code, password, navigate, type) => ({
    type: CONFIRM_USER_REQUEST,
    payload: { username, code, password, navigate, type },
});

export const confirmUserResult = (result, showConfirm, error) => ({
    type: CONFIRM_USER_RESULT,
    payload: { result, showConfirm, error }
});

export const confirmUserVerificateCodeRequest = (values) => ({
    type: CONFIRM_USER_VERIFICATE_CODE_REQUEST,
    payload: values
});

export const confirmUserVerificateCodeResult = (result) => ({
    type: CONFIRM_USER_VERIFICATE_CODE_RESULT,
    payload: result
});
